var _rect, _path, _rect2, _rect3, _path2, _path3, _path4, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRounding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 276,
    viewBox: "0 0 552 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 276,
    fill: "#F2F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152 99.561V87H162V99.561H202V87H212V99.561H232V190H132V99.561H152ZM142 109.61V124.683H222V109.61H142ZM222 134.732H142V179.951H222V134.732Z",
    fill: "#C8D2D7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 165,
    width: 10,
    height: 25,
    fill: "#058CD7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 180,
    width: 10,
    height: 25,
    transform: "rotate(90 157 180)",
    fill: "#058CD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.981 94.4118C370.566 88.6143 379.142 85.6121 387.896 86.0402C396.65 86.4683 404.894 90.2932 410.884 96.7057C416.875 103.118 420.143 111.615 419.995 120.4C419.848 129.184 416.298 137.566 410.095 143.773L381.787 172.156L363.975 190L324.526 150.46L317.861 143.768C311.677 137.557 308.143 129.18 308.004 120.406C307.865 111.632 311.133 103.147 317.117 96.7429C323.101 90.3384 331.333 86.5152 340.076 86.0802C348.819 85.6453 357.388 88.6326 363.975 94.4118H363.981ZM381.782 156.799L402.433 136.092C404.561 133.959 406.249 131.427 407.4 128.64C408.552 125.853 409.144 122.867 409.144 119.85C409.144 116.834 408.552 113.847 407.4 111.06C406.249 108.273 404.561 105.741 402.433 103.608C400.305 101.475 397.779 99.7834 394.999 98.6291C392.219 97.4748 389.24 96.8807 386.231 96.8807C383.222 96.8807 380.242 97.4748 377.462 98.6291C374.682 99.7834 372.156 101.475 370.028 103.608L363.975 109.67L357.922 103.603C353.625 99.2952 347.797 96.8752 341.72 96.8752C335.643 96.8752 329.815 99.2952 325.518 103.603C321.22 107.91 318.806 113.753 318.806 119.845C318.806 125.937 321.22 131.779 325.518 136.087L332.194 142.779L363.975 174.638L381.776 156.794L381.782 156.799Z",
    fill: "#C8D2D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.5 170.5L364 190V174.5L376.5 162L383.5 170.5Z",
    fill: "#058CD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.5 162L364 174.5V190L343.5 169.5L351.5 162Z",
    fill: "#058CD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341,
    cy: 120,
    r: 33,
    stroke: "#058CD7",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 120,
    r: 33,
    stroke: "#058CD7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounding);
export default __webpack_public_path__ + "static/media/rounding.826abaf76b02117a6ac5e59070b450e9.svg";
export { ForwardRef as ReactComponent };